import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';


const WebhookGroup = () => {
  return (
    <div className="setup-webhooks pt-12">
        <button className="webhook-button" onClick={copyAndGoGroup}>Copy & Go</button>
    </div>
  );
};

const WebhookGroupImage = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <img src="/assets/images/webhook-groups.png" alt="Webhook Group" className="w-3/4 rounded-lg my-2" />
    </div>
  );
};

const WebhookGroupEnabledImage = () => {
    return (
      <div className="flex justify-center items-center h-full">
        <img src="/assets/images/groups-enabled.png" alt="Webhook Group" className="w-3/4 rounded-lg my-2" />
      </div>
    );
  };

function copyAndGoGroup() {
    const webhookUrl = "https://us-central1-joltchat.cloudfunctions.net/groupCreateUpdateDestroy";
    navigator.clipboard.writeText(webhookUrl)
      .then(function() {
        console.log("Webhook URL copied to clipboard:", webhookUrl);
        window.open("https://api.planningcenteronline.com/webhooks#/subscriptions/new", "_blank");
      })
      .catch(function(error) {
        console.error("Error copying webhook URL to clipboard:", error);
      });
  }

  const WebhookMember = () => {
    return (
      <div className="setup-webhooks pt-12">
          <button className="webhook-button" onClick={copyAndGoMember}>Copy & Go</button>
      </div>
    );
  };

  const WebhookMemberImage = () => {
    return (
      <div className="flex justify-center items-center h-full">
        <img src="/assets/images/webhook-members.png" alt="Webhook Member" className="w-3/4 rounded-lg my-2" />
      </div>
    );
  };

  const WebhookMemberEnabledImage = () => {
    return (
      <div className="flex justify-center items-center h-full">
        <img src="/assets/images/membership-enabled.png" alt="Webhook Group" className="w-3/4 rounded-lg my-2" />
      </div>
    );
  };

  function copyAndGoMember() {
    const webhookUrl = "https://us-central1-joltchat.cloudfunctions.net/groupMemberCreateUpdateDestroy";
    navigator.clipboard.writeText(webhookUrl)
      .then(function() {
        console.log("Webhook URL copied to clipboard:", webhookUrl);
        window.open("https://api.planningcenteronline.com/webhooks#/subscriptions/new", "_blank");
      })
      .catch(function(error) {
        console.error("Error copying webhook URL to clipboard:", error);
      });
  }

const FinishSetup = () => {
  const navigate = useNavigate();
  const setupSteps = [
    {
      title: 'Keep us recognized on Planning Center',
      description: 'Click this button to copy the webhook link. A new page will open where you can paste the link and set up the webhook.',
      content: <WebhookGroup />
    },
    {
      title: 'Paste in the URL',
      description: 'It should look like this',
      content: <WebhookGroupImage />
    },
    {
      title: 'Enable Groups',
      description: 'Scroll to the bottom of the page where it says "Groups" and enable all 3 for "Group" and click "Save"',
      content: <WebhookGroupEnabledImage />
    },
    {
      title: 'Do the same thing for Members',
      description: 'Click this button to copy the members webhook link. A new page will open where you can paste the link and set up the webhook.',
      content: <WebhookMember />
    },
    {
        title: 'Paste in the URL',
        description: 'It should look like this. Make sure its the Members URL not the Groups URL.',
        content: <WebhookMemberImage />
    },
    {
        title: 'Enable Memberships',
        description: 'Scroll to the bottom of the page where it says "Groups" and enable all 3 for "Membership" and click "Save"',
        content: <WebhookMemberEnabledImage />
    },
    {
      title: 'Enjoy the full experience of JoltChat!',
      description: 'That was easy! And the good news is that was the hardest part! It\'s time to kick your feet up and let JoltChat do the heavy lifting for you!',
      content: <motion.button
                          onClick={() => navigate('/dashboard')}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ 
                            duration: 0.5,
                            delay: 2 
                          }}
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          className="mt-14 mb-4 px-8 py-5 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-full font-bold text-xl shadow-lg hover:shadow-xl transition-shadow"
                        >
                          View your Dashboard
                        </motion.button>
  }
  ];

  return (
    <div className='min-h-screen min-w-screen p-8 dashboard-element-bg'>
      <motion.div 
          className='dashboard-main-color rounded-3xl w-full p-8 mt-20'
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut"
          }}
        >
        <div className="flex flex-col">
        <div className="border-b border-gray-700 pb-4 mb-4">
            <motion.h1 
              className="text-3xl font-bold text-white"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ 
                duration: 1.5,
                ease: "easeOut"
              }}
            >
              Finish your set up
            </motion.h1>
          </div>
          <div className="dashboard-element-bg rounded-lg p-8">
            <div className="w-full">
              <motion.p 
                className="text-xl text-white mb-24"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.5,
                  ease: "easeOut"
                }}
              >
                Almost done! To have a seamless flow with your Planning Center, finish these final steps!
              </motion.p>              
                           <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.8,
                  ease: "easeOut"
                }}
              >
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  navigation
                  pagination={{ type: 'progressbar' }}
                  className="w-full max-w-4xl mx-auto"
                >
                  {setupSteps.map((step, index) => (
                    <SwiperSlide key={index}>
                      <div className="flex flex-col items-center justify-center p-6 text-center">
                        <h2 className="text-3xl font-bold mt-4 mb-4 text-white">
                          Step {index + 1}: {step.title}
                        </h2>
                        <p className="text-gray-300 w-2/3 mb-6 mt-3 text-lg">{step.description}</p>
                        <div className="mt-4">
                          {step.content}
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default FinishSetup;